import ObserveNavigation from "./observeNavigation"
import Cookies from "../cookies";

export default {
    /**
     * @param {{initFunc: ()=>void, observeSelector: string}[]} scriptList 
     */
    initScript: function (scriptList) {
      scriptList.forEach(script=>{
        script.initFunc();
      });
      ObserveNavigation.setObservedScripts(scriptList);
    },

    tellBackendThatJavascriptIsEnabled: function () {
      if (Cookies.cookieExists('IsJavascriptDisabled')) {
        let cookieValue = Cookies.getCookieValue('IsJavascriptDisabled');
        Cookies.removeCookie('IsJavascriptDisabled');
        if (cookieValue === 'true') {
          location.reload();
        } 
      }
    }
  };